import { useState } from 'react';
import { Button, Caption, Input, List, Modal, Section } from '@telegram-apps/telegram-ui';
import { useBulkAction } from '../hooks/useProductMutations';

function confirmTelegram(message: string): Promise<boolean> {
  return new Promise((resolve) => {
    const tg = window.Telegram?.WebApp;
    if (tg?.showConfirm) {
      tg.showConfirm(message, (ok: boolean) => resolve(ok));
    } else {
      resolve(window.confirm(message));
    }
  });
}

export function BulkActionSheet({
  open,
  ids,
  onClose,
  onCompleted,
}: {
  open: boolean;
  ids: string[];
  onClose: () => void;
  onCompleted: () => void;
}) {
  const bulk = useBulkAction();
  const [tagInput, setTagInput] = useState('');
  const [phase, setPhase] = useState<
    'menu' | 'add_tags' | 'remove_tags'
  >('menu');

  const runSuccess = () => {
    onCompleted();
    onClose();
    setPhase('menu');
    setTagInput('');
  };

  const doArchive = () => {
    bulk.mutate({ ids, action: 'archive' }, { onSuccess: runSuccess });
  };
  const doActivate = () => {
    bulk.mutate({ ids, action: 'activate' }, { onSuccess: runSuccess });
  };
  const doDelete = async () => {
    const ok = await confirmTelegram('Удалить выбранные товары? Их можно будет восстановить только из бэка БД.');
    if (!ok) return;
    bulk.mutate({ ids, action: 'delete' }, { onSuccess: runSuccess });
  };

  const applyTagsAction = (action: 'add_tags' | 'remove_tags') => {
    const tags = tagInput
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
    if (!tags.length) return;
    bulk.mutate({ ids, action, tags }, { onSuccess: runSuccess });
  };

  const busy = bulk.isPending;

  return (
    <Modal open={open} onOpenChange={(v) => !v && onClose()} header={<Modal.Header>Действия ({ids.length})</Modal.Header>} dismissible>
      {open && (
        <List style={{ maxHeight: '75vh', overflowY: 'auto', paddingBottom: 16 }}>
          {bulk.isError && (
            <Caption style={{ padding: '0 16px', color: 'var(--tgui--destructive_text_color)' }}>
              {(bulk.error as Error)?.message}
            </Caption>
          )}

          {phase === 'menu' && (
            <>
              <Section header=" ">
                <Button mode="filled" stretched size="m" disabled={busy} onClick={() => void doActivate()}>
                  Активировать
                </Button>
                <Button mode="filled" stretched size="m" disabled={busy} onClick={() => void doArchive()}>
                  Архивировать
                </Button>
                <Button mode="filled" stretched size="m" disabled={busy} onClick={() => void doDelete()} style={{ marginTop: 8 }}>
                  Удалить
                </Button>
              </Section>
              <Section header=" ">
                <Button
                  mode="bezeled"
                  stretched
                  size="m"
                  disabled={busy}
                  onClick={() => setPhase('add_tags')}
                >
                  Добавить тег…
                </Button>
                <Button mode="bezeled" stretched size="m" disabled={busy} onClick={() => setPhase('remove_tags')}>
                  Убрать тег…
                </Button>
              </Section>
              <Section header=" ">
                <Button mode="plain" stretched size="m" type="button" onClick={() => onClose()} disabled={busy}>
                  Отмена
                </Button>
              </Section>
            </>
          )}

          {phase !== 'menu' && (
            <Section header={phase === 'add_tags' ? 'Теги (добавить)' : 'Теги (убрать)'}>
              <Input
                header="Через запятую"
                value={tagInput}
                onChange={(ev) => setTagInput(ev.target.value)}
              />
              <Button
                mode="filled"
                stretched
                size="m"
                disabled={busy}
                loading={busy}
                onClick={() => applyTagsAction(phase)}
              >
                Применить
              </Button>
              <Button mode="plain" stretched size="m" disabled={busy} onClick={() => setPhase('menu')}>
                Назад
              </Button>
            </Section>
          )}
        </List>
      )}
    </Modal>
  );
}
